/* eslint-disable react/jsx-pascal-case */
import { createContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import './App.css'

// import Login from "./pages/auth/login/Login";
// import Signup from "./pages/auth/singup/Signup";
// import Admin from "./pages/admin_folder/admin/admin";
// import Dashboard from "./pages/dashboard/Dashboard";
// import AdminSignup from "./pages/auth/adminsingup/adminsingup";
// import CartPage from "./pages/cart/CardPage";
// import LeavePliocy from "./pages/LeavePolicy";
// import PolicyAdd from "./pages/admin_folder/Policy/policy_add";
// import ApplyLeave from "./pages/applyleave/ApplyLeave";
// import LeaveDispaly from "./pages/applyleave/Leavedispaly";
// import RejectedLeaves from "./pages/admin_folder/rejectedleave/RejectedLeave";
// import MyLeave from "./pages/applyleave/MyLeave";
// import Team from "./pages/team/Team";
// import ApproveLeave from "./pages/admin_folder/rejectedleave/ApproveLeave";
// import ApplyLeaveManager from "./pages/applyleavemanager/ApplyLeaveManager";
// import SingleAttendace from "./pages/SingleAttendance/SingleAttendance";
// import SingleTimeSheet from "./pages/SingleAttendance/SigleTimeSheet";
// import AdminHelp from "./pages/attence/AdminHelp";
import FirstPage from "./pages/FirstPage";
import LandingDashboard from "./pages/dashboard/LandingDashboard";
import EmployeeForm from "./pages/Employee/EmployeeForm";
import AdminProductDetails from "./pages/Employee/EmployeeDetails";
import OrganizationTree from "./pages/Organization/OrganizationTree";
import Department from "./pages/department/Department";
import HelpPage from "./pages/attence/HelpPage";
import EmployeeDashboard from "./pages/Employee/EmployeeDashboard";
import CandidateData from "./pages/Employee/CandidateData";
import Attendance from "./pages/Attendance/Attendance";
import Templates from "./pages/Template/Template";
import TemplatePreview from "./pages/Template/TemplatePreview";
import LeavePolicy from "./pages/Policy/LeavePolicy";
import AdminHeader from "./pages/header/adminHeader";
import { attemptRefresh, startRefreshTimer } from "./pages/utills/RefreshTimer";
import CallBack from "./pages/CallBack"
import axiosInstance from "./pages/utills/axiosInstance";
import AllEmployeeAttendance from "./pages/Attendance/AllEmployeeAttendance";
import OffboardingForm from "./pages/Offboarding/OffboardingForm";
import MyOffboardingRequest from "./pages/Offboarding/MyOffboardingRequest";
import RMApprovalDashboard from "./pages/Offboarding/RMApprovalDashboard";
import AdminApprovalDashboard from "./pages/Offboarding/AdminFinalApproval";
import LeaveBalance from "./pages/Leave/LeaveBalance";
import LeaveRequest from "./pages/Leave/LeaveRequest";
import RequestedLeaves from "./pages/Leave/ReaquestLeave";
import LeaveApproval from "./pages/Leave/LeaveApproval";
import OdDashboard from "./pages/Attendance/OdDashboard";
import MyODRequests from "./pages/Attendance/MyODRequests";
import PayrollDashboard from "./pages/Payroll/PayrollDashboard";
import PayrollComponents from "./pages/Payroll/PayrollComponents";
import PayrollPackage from "./pages/Payroll/PayrollPackage";
import PayRun from "./pages/Payroll/PayRun";
import PaySlip from "./pages/Payroll/PaySlip";
import RoleManagement from "./pages/RoleManagement/RoleManagement";

export const Usercontext = createContext();

export const origin = process.env.REACT_APP_BACKEND_URL ?? window.location.origin;

function App() {
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setIsAuthenticated(false);
      setIsLoading(false);
      return;
    }
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    const validateAuth = async (retries = 1) => {
      try {
        await axiosInstance.get('/auth/user');
        setIsAuthenticated(true);
      } catch (err) {
        console.warn("App load: Auth attempt failed:", err.response?.status);
        if (err.response?.status === 401 && retries > 0) {
          const refreshed = await attemptRefresh();
          if (refreshed) {
            console.log("App load: Refreshed and retrying");
            await validateAuth(0);
          } else {
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            localStorage.removeItem('data');
            setIsAuthenticated(false);
          }
        } else {
          localStorage.removeItem('token');
          localStorage.removeItem('profile');
          localStorage.removeItem('data');
          setIsAuthenticated(false);
        }
      } finally {
        setIsLoading(false);
        if (isAuthenticated) startRefreshTimer();
      }
    };

    validateAuth(1);
  }, []);

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <Usercontext.Provider value={{ title, setTitle }}>
        <div className="main">
          <AdminHeader />
          <div className="content">
            <Routes>
              <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" /> : <FirstPage />} />
              <Route path="/auth/microsoft/callback" element={<CallBack />} />
              <Route path="/dashboard" element={<LandingDashboard />} />
              <Route path="/employeedata" element={<EmployeeDashboard />} />
              <Route path="/employee" element={<EmployeeForm />} />
              <Route path="/employee/details" element={<AdminProductDetails />} />
              <Route path="/candidatedata" element={<CandidateData />} />
              <Route path="/department" element={<Department />} />
              <Route path="/emptree" element={<OrganizationTree />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/all-employee-attendance" element={<AllEmployeeAttendance />} />
              <Route path="/leavebalance" element={<LeaveBalance />} />
              <Route path="/applyleave" element={<LeaveRequest />} />
              <Route path="/leaverequest" element={<RequestedLeaves />} />
              <Route path="/leaveapproval" element={<LeaveApproval />} />
              <Route path="/od" element={<OdDashboard />} />
              <Route path="/my-od" element={<MyODRequests />}/>
              <Route path="/templates" element={<Templates />} />
              <Route path="/template/:id" element={<TemplatePreview />} />
              <Route path="/leavepolicy" element={<LeavePolicy />} />
              <Route path="/help" element={<HelpPage />} />
              <Route path="/offboarding" element={<OffboardingForm />} />
              <Route path="/myoffboarding" element={<MyOffboardingRequest />} />
              <Route path="/rmapproval" element={<RMApprovalDashboard />} />
              <Route path="/adminapproval" element={<AdminApprovalDashboard />} />
              <Route path="/payrolldashboard" element={<PayrollDashboard />} />
              <Route path="/payrollcomponents" element={<PayrollComponents />} />
              <Route path="/payrollpackage" element={<PayrollPackage />} />
              <Route path="/payrollpayrun" element={<PayRun />} />
              <Route path="/payrollslip" element={<PaySlip />} />
              <Route path="/access-control" element={<RoleManagement />} />

              {/* <Route path="/" element={<FirstPage />} />
              <Route path="/hrms/admin" element={<Admin />} />
              <Route path="/hrms/login" element={<Login />} />
              <Route path="/hrms/register" element={<Signup />} />
              <Route path="/hrms/attendance" element={<Attendance />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/adminsignup" element={<AdminSignup />} />
              <Route path="/auth/microsoft/callback" element={} />
              <Route path="/leaveadd" element={<PolicyAdd />} />
              <Route path="/userpolicy" element={<LeavePliocy />} />
              <Route path="/leaveapply" element={<ApplyLeave />} />
              <Route path="/requestleave" element={<ApplyLeaveManager />} />
              <Route path="/rejectdispaly" element={<RejectedLeaves />} />
              <Route path="/leavedispaly" element={<LeaveDispaly />} />
              <Route path="/myleave" element={<MyLeave />} />
              <Route path="/approve" element={<ApproveLeave />} />
              <Route path="/attendance" element={<SingleAttendace />} />
              <Route path="/singletimesheet" element={<SingleTimeSheet />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/team" element={<Team />} />
              <Route path="/adminhelp" element={<AdminHelp />} /> */}
            </Routes>
          </div>
        </div>
      </Usercontext.Provider>
    </div>
  );
}

export default App;
